var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFollowiconX = function SvgFollowiconX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 12,
    r: 10.5,
    fill: "#FFF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#446CB3",
    d: "M15.642 6.312h1.93l-4.216 4.819 4.96 6.556h-3.884l-3.041-3.976-3.48 3.976H5.98l4.51-5.153L5.73 6.312h3.982l2.75 3.635zm-.677 10.22h1.07L9.131 7.407H7.985z"
  })));
};
export default SvgFollowiconX;